module.exports = __webpack_public_path__ + "static/media/cjc.ed637003.png";